import React from 'react'
import { LongCellStyles } from './Style'
import { Tooltip } from '@mui/material'

/**
 * A custom table cell renderer tailored for long text content.
 * Designed to integrate seamlessly with standard headless table libraries (like `@tanstack/react-table`).
 *
 * **Key Mechanics:**
 * - **Tooltip Truncation:** Wraps the cell content in a Material-UI `<Tooltip>`, allowing truncated text to be fully read on hover.
 * - **Column Meta Configuration:** Reads from `column.columnDef.meta` to dynamically adjust behavior per column (e.g., cell width, empty state text, showing the creator's name).
 * - **Empty State Handling:** Renders a styled fallback `div` when the cell `value` is empty or falsy.
 * 
 * @param {Object} props - Cell rendering props provided by the table instance.
 * @param {Object} props.cell - The cell object API.
 * @param {Function} props.cell.getValue - Invoked to retrieve the underlying data value for this cell.
 * @param {Object} props.column - The column object API.
 * @param {Object} [props.column.columnDef] - The definition object for the current column.
 * @param {Object} [props.column.columnDef.meta] - Custom meta options defined in the column configuration.
 * @param {string|number} [props.column.columnDef.meta.width] - Injected into the styled wrapper to enforce cell boundaries.
 * @param {boolean} [props.column.columnDef.meta.showCreatedBy] - If true, prefixes the text with the message author's name.
 * @param {string} [props.column.columnDef.meta.emptyText] - Fallback text to display when there is no value. Defaults to "ממתין לתגובה".
 * @param {Object} props.row - The row object API.
 * @param {Object} props.row.original - The raw data object for the current row.
 * @param {string} [props.row.original.last_message_create_by] - The author's name, used if `showCreatedBy` is enabled.
 * 
 * @example
 * // Typical usage inside a column definition setup:
 * {
 *   accessorKey: 'lastMessage',
 *   header: 'Message Details',
 *   cell: LongTextCell,
 *   meta: { 
 *     width: '250px', 
 *     showCreatedBy: true, 
 *     emptyText: 'אין הודעות' 
 *   }
 * }
 */
const LongTextCell = (props) => {
    const { cell, column, row } = props
    const { meta } = column?.columnDef || {}

    let value = cell.getValue()

    return (
        <LongCellStyles width={meta?.width}>
            {value ?
                <Tooltip title={value} placement='right'>
                    <span>
                        {/* התאמה די למקרה ספציפי מומלץ להוציא את זה למקום היעודי שבו משתמשים */}
                        {meta?.showCreatedBy ?
                            <b>{row.original.last_message_create_by}: {" "}</b> : <></>}
                        {value}
                    </span>
                </Tooltip> :
                <div className='no-messages'>
                    {meta?.emptyText || "ממתין לתגובה"}
                </div>
            }
        </LongCellStyles>
    )
}

export default LongTextCell